<div class="min-h-screen bg-gray-50 py-8">
  <div class="max-w-2xl mx-auto px-4">
    <div class="bg-white rounded-lg shadow-lg p-8">
      <!-- Header -->
      <div class="flex items-center justify-between mb-8">
        <h1 class="text-3xl font-bold">
          {{ editingEquipment?.id ? 'Equipment bearbeiten' : 'Neues Equipment' }}
        </h1>
        <button 
          (click)="navigateBack()"
          class="text-gray-500 hover:text-gray-700 text-2xl">
          ✕
        </button>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="text-center py-8">
        <p class="text-gray-600">Laden...</p>
      </div>

      <!-- Form -->
      <form *ngIf="!isLoading && editingEquipment" (ngSubmit)="saveEquipment()" class="space-y-6">
        <!-- Name -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Name *
          </label>
          <input 
            type="text"
            [(ngModel)]="editingEquipment.name"
            name="name"
            required
            placeholder="z.B. LED Wall 5mm"
            class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent">
        </div>

        <!-- Dimensions Section -->
        <div class="border-t pt-6">
          <h3 class="text-lg font-semibold mb-4 text-gray-800">Abmessungen (Aufbau)</h3>
          
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Breite (m) *
              </label>
              <input 
                type="number"
                step="0.1"
                [(ngModel)]="editingEquipment.width"
                name="width"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Höhe (m) *
              </label>
              <input 
                type="number"
                step="0.1"
                [(ngModel)]="editingEquipment.height"
                name="height"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent">
            </div>
          </div>
        </div>

        <!-- Technical Specs Section -->
        <div class="border-t pt-6">
          <h3 class="text-lg font-semibold mb-4 text-gray-800">Technische Spezifikationen</h3>
          
          <div class="space-y-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Pixel Pitch (mm) *
              </label>
              <input 
                type="number"
                step="0.1"
                [(ngModel)]="editingEquipment.pixelPitch"
                name="pixelPitch"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent">
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Länge Aufbau (m) *
              </label>
              <input 
                type="number"
                step="0.01"
                [(ngModel)]="editingEquipment.length"
                name="length"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent">
            </div>
          </div>
        </div>

        <!-- Transport Dimensions Section -->
        <div class="border-t pt-6">
          <h3 class="text-lg font-semibold mb-4 text-gray-800">Transport Abmessungen</h3>
          
          <div class="grid grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Transport Breite (m) *
              </label>
              <input 
                type="number"
                step="0.1"
                [(ngModel)]="editingEquipment.deliveryWidth"
                name="deliveryWidth"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Transport Höhe (m) *
              </label>
              <input 
                type="number"
                step="0.1"
                [(ngModel)]="editingEquipment.deliveryHeight"
                name="deliveryHeight"
                required
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent">
            </div>
          </div>
        </div>

        <!-- Availability Section -->
        <div class="border-t pt-6">
          <h3 class="text-lg font-semibold mb-4 text-gray-800">Status</h3>
          
          <label class="flex items-center">
            <input 
              type="checkbox"
              [(ngModel)]="editingEquipment.isAvailable"
              name="isAvailable"
              class="w-5 h-5 text-brand-accent rounded focus:outline-none focus:ring-2 focus:ring-brand-accent">
            <span class="ml-3 text-sm font-medium text-gray-700">
              Verfügbar
            </span>
          </label>
        </div>

        <!-- Blocked Periods Section -->
        <div class="border-t pt-6">
          <h3 class="text-lg font-semibold mb-4 text-gray-800">Sperrzeiten</h3>
          <p class="text-sm text-gray-600 mb-4">
            Legen Sie Zeiträume fest, in denen das Equipment nicht verfügbar sein soll (z.B. Wartung, Reparatur).
          </p>

          <!-- Add New Blocked Period -->
          <div class="bg-gray-50 rounded-lg p-4 mb-6">
            <h4 class="font-semibold text-gray-800 mb-4">Neue Sperrzeit hinzufügen</h4>
            
            <div class="space-y-4">
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    Startdatum *
                  </label>
                  <input 
                    type="datetime-local"
                    [(ngModel)]="newBlockedPeriod.startDate"
                    name="blockedStartDate"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent">
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    Enddatum *
                  </label>
                  <input 
                    type="datetime-local"
                    [(ngModel)]="newBlockedPeriod.endDate"
                    name="blockedEndDate"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent">
                </div>
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Kommentar (optional)
                </label>
                <input 
                  type="text"
                  [(ngModel)]="newBlockedPeriod.comment"
                  name="blockedComment"
                  placeholder="z.B. Wartung, Reparatur, Transport"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-accent">
              </div>

              <button 
                type="button"
                (click)="addBlockedPeriod()"
                class="w-full px-4 py-2 bg-brand-accent text-white rounded-lg hover:bg-brand-primary font-semibold transition">
                + Sperrzeit hinzufügen
              </button>
            </div>
          </div>

          <!-- List of Blocked Periods -->
          <div *ngIf="editingEquipment.blockedPeriods && editingEquipment.blockedPeriods.length > 0" class="space-y-3">
            <h4 class="font-semibold text-gray-800 mb-3">Bestehende Sperrzeiten ({{ editingEquipment.blockedPeriods.length }})</h4>
            
            <div *ngFor="let period of editingEquipment.blockedPeriods; let i = index" 
              class="bg-orange-50 border border-orange-200 rounded-lg p-4 flex justify-between items-start">
              <div class="flex-1">
                <div class="text-sm text-gray-700 mb-1">
                  <strong>{{ formatDate(period.startDate) }}</strong> bis <strong>{{ formatDate(period.endDate) }}</strong>
                </div>
                <div *ngIf="period.comment" class="text-sm text-gray-600 italic">
                  {{ period.comment }}
                </div>
              </div>
              <button 
                type="button"
                (click)="removeBlockedPeriod(i)"
                class="ml-4 px-3 py-1 text-red-600 hover:bg-red-100 rounded transition">
                ✕
              </button>
            </div>
          </div>

          <div *ngIf="!editingEquipment.blockedPeriods || editingEquipment.blockedPeriods.length === 0" 
            class="text-center py-4 text-gray-500">
            Keine Sperrzeiten vorhanden
          </div>
        </div>

        <!-- Actions -->
        <div class="border-t pt-6 flex gap-3">
          <button 
            type="submit"
            [disabled]="isSaving"
            class="flex-1 px-6 py-3 bg-brand-accent text-white rounded-lg hover:bg-brand-primary font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition">
            {{ isSaving ? 'Speichert...' : 'Speichern' }}
          </button>
          <button 
            type="button"
            (click)="navigateBack()"
            [disabled]="isSaving"
            class="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition">
            Abbrechen
          </button>
          <button 
            *ngIf="editingEquipment.id"
            type="button"
            (click)="deleteEquipment()"
            [disabled]="isSaving"
            class="flex-1 px-6 py-3 bg-red-500 text-white rounded-lg hover:bg-red-600 font-semibold disabled:opacity-50 disabled:cursor-not-allowed transition">
            {{ isSaving ? 'Löscht...' : 'Löschen' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
